import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IChannelRepository } from '../../repositories/interfaces/iChannelRepository';
import { IGetChannelsMiniEPGParams } from '../../entities/iChannels';

export interface IGetChannelMiniEPGUseCase {
    execute(params: IGetChannelsMiniEPGParams): Promise<string[]>;
}

export class GetChannelMiniEpgUseCase implements IGetChannelMiniEPGUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get channelsRepo(): IChannelRepository {
        return container.resolve<IChannelRepository>(DI.REPOSITORIES.IChannelRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters}
    }
    async execute(params: IGetChannelsMiniEPGParams): Promise<string[]> {
        const response = await this.channelsRepo.getChannelsMiniEPG(params);
        return response.data.ids || [];
    }
}
